import {
  FETCH_CNC_MANUAL_WEBORDER_STATUS,
  FETCH_CNC_MANUAL_WEBORDER_STATUS_SUCCESS,
  FETCH_CNC_MANUAL_WEBORDER_STATUS_FAILURE,
  RESET_CNC_MANUAL_WEBORDER_STATUS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS_SUCCESS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS_FAILURE,
  FETCH_CNC_SCANNED_WEBORDER_STATUS,
  FETCH_CNC_SCANNED_WEBORDER_STATUS_SUCCESS,
  FETCH_CNC_SCANNED_WEBORDER_STATUS_FAILURE,
  RESET_CNC_SCANNED_WEBORDER_STATUS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS_SUCCESS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS_FAILURE,
  SET_CNC_SCANNED_DATA,
} from "./cncWebOrderTypes";

const initialState = {
  manualWebOrder: {
    loading: false,
    woNo: undefined,
    woId: undefined,
    woStatus: undefined,
    customerEntry: undefined,
    error: undefined,
  },
  scannedWeborder: {
    scannedData: undefined,
    loading: false,
    woNo: undefined,
    woId: undefined,
    woStatus: undefined,
    customerEntry: undefined,
    error: undefined,
  },
};

const cncWebOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CNC_MANUAL_WEBORDER_STATUS: {
      const { weborderNo } = action.payload;
      return {
        ...state,
        manualWebOrder: {
          ...state.manualWebOrder,
          woNo: weborderNo,
          loading: true,
        },
      };
    }
    case FETCH_CNC_MANUAL_WEBORDER_STATUS_SUCCESS: {
      const { woStatus, woId, woNo, pickup_store_location } = action.payload;
      return {
        ...state,
        manualWebOrder: {
          ...state.manualWebOrder,
          loading: false,
          error: undefined,
          woStatus,
          woId,
          woNo,
          pickup_store_location,
        },
      };
    }
    case FETCH_CNC_MANUAL_WEBORDER_STATUS_FAILURE: {
      const weborderfetchError = action.payload.error;
      return {
        ...state,
        manualWebOrder: {
          ...state.manualWebOrder,
          loading: false,
          error: weborderfetchError,
        },
      };
    }
    case RESET_CNC_MANUAL_WEBORDER_STATUS: {
      return {
        ...state,
        manualWebOrder: {
          ...initialState.manualWebOrder,
        },
      };
    }
    case MODIFY_CNC_MANUAL_WEBORDER_STATUS: {
      const { woId, woNo } = action.payload;
      return {
        ...state,
        manualWebOrder: {
          ...state.manualWebOrder,
          woId,
          woNo,
          loading: true,
        },
      };
    }
    case MODIFY_CNC_MANUAL_WEBORDER_STATUS_SUCCESS: {
      const { woStatus, woId, woNo, customerEntry } = action.payload;
      return {
        ...state,
        manualWebOrder: {
          ...state.manualWebOrder,
          loading: false,
          error: undefined,
          woStatus: woStatus,
          woId: woId,
          woNo: woNo,
          customerEntry: customerEntry,
        },
      };
    }
    case MODIFY_CNC_MANUAL_WEBORDER_STATUS_FAILURE: {
      const weborderfetchError = action.payload.error;
      return {
        ...state,
        manualWebOrder: {
          ...state.manualWebOrder,
          loading: false,
          error: weborderfetchError,
        },
      };
    }
    case SET_CNC_SCANNED_DATA: {
      const { text } = action.payload;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          scannedData: text,
        },
      };
    }
    case FETCH_CNC_SCANNED_WEBORDER_STATUS: {
      const { weborderNo } = action.payload;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          woNo: weborderNo,
          loading: true,
        },
      };
    }
    case FETCH_CNC_SCANNED_WEBORDER_STATUS_SUCCESS: {
      const { woStatus, woId, woNo, pickup_store_location } = action.payload;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          loading: false,
          error: undefined,
          woStatus,
          woId,
          woNo,
          pickup_store_location,
        },
      };
    }
    case FETCH_CNC_SCANNED_WEBORDER_STATUS_FAILURE: {
      const weborderfetchError = action.payload.error;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          loading: false,
          error: weborderfetchError,
        },
      };
    }
    case RESET_CNC_SCANNED_WEBORDER_STATUS: {
      return {
        ...state,
        scannedWeborder: {
          ...initialState.scannedWeborder,
        },
      };
    }
    case MODIFY_CNC_SCANNED_WEBORDER_STATUS: {
      const { woId, woNo } = action.payload;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          woId,
          woNo,
          loading: true,
        },
      };
    }
    case MODIFY_CNC_SCANNED_WEBORDER_STATUS_SUCCESS: {
      const { woStatus, woId, woNo, customerEntry } = action.payload;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          loading: false,
          error: undefined,
          woStatus: woStatus,
          woId: woId,
          woNo: woNo,
          customerEntry: customerEntry,
        },
      };
    }
    case MODIFY_CNC_SCANNED_WEBORDER_STATUS_FAILURE: {
      const weborderfetchError = action.payload.error;
      return {
        ...state,
        scannedWeborder: {
          ...state.scannedWeborder,
          loading: false,
          error: weborderfetchError,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
};

export default cncWebOrderReducer;
